import { forwardRef } from 'react';
import { Document, Page } from 'react-pdf';
import HighlightCanvas from './HighlightCanvas';
import LoadingSpinner from './LoadingSpinner';
import { PDF_WIDTH_LANDSCAPE } from '../../../utils/insuranceSearchUtil';

/**
 * PDFビューワーコンポーネント
 * react-pdfを使用してPDFを表示し、ハイライトを重ねて表示
 */
const PdfViewer = forwardRef(({
  pdfFile,
  pdfOptions,
  currentPage,
  zoomLevel,
  isRendering,
  highlightsPolygon,
  highlightCanvasRef,
  onDocumentLoadSuccess,
  onDocumentLoadError,
  onPageLoadSuccess,
  onPageRenderSuccess,
  onPageLoadError,
  customTextRenderer,
  onGetTextSuccess,
  onRenderTextLayerSuccess,
  scrollContainerRef,
  isDragging,
  interactionMode,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onMouseLeave,
}, pdfContainerRef) => {
  return (
    <div
      ref={scrollContainerRef}
      className="pdf-frame-container"
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      style={{ cursor: interactionMode === 'select' ? 'text' : (isDragging ? 'grabbing' : 'grab') }}
    >
      {/* PDF表示領域 */}
      <div
        className="pdf-content"
        style={{
          userSelect: interactionMode === 'select' ? 'text' : 'none',
          WebkitUserSelect: interactionMode === 'select' ? 'text' : 'none',
          WebkitTouchCallout: interactionMode === 'select' ? 'default' : 'none',
        }}
      >
        {/* PDFドキュメント表示エリア */}
        {pdfFile && (
          <Document
            file={pdfFile}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
            loading={<LoadingSpinner />}
            error={null}
            options={pdfOptions}
          >
            <div ref={pdfContainerRef} className="pdf-page-wrapper">
              <Page
                width={PDF_WIDTH_LANDSCAPE}
                pageNumber={currentPage}
                onLoadSuccess={onPageLoadSuccess}
                onRenderSuccess={onPageRenderSuccess}
                onLoadError={onPageLoadError}
                loading={<LoadingSpinner />}
                scale={zoomLevel / 100}
                renderTextLayer={true}
                customTextRenderer={customTextRenderer}
                onGetTextSuccess={onGetTextSuccess}
                onRenderTextLayerSuccess={onRenderTextLayerSuccess}
                renderAnnotationLayer={false}
                style={{
                  borderRadius: '8px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                  opacity: isRendering ? 0.7 : 1,
                  transition: 'opacity 0.2s ease',
                }}
              />
              {/* ハイライト用キャンバス */}
              <HighlightCanvas
                ref={highlightCanvasRef}
                highlightsPolygon={highlightsPolygon}
              />
            </div>
          </Document>
        )}
        {/* レンダリング中オーバーレイ */}
        {isRendering && (
          <div className="pdf-rendering-overlay">
            レンダリング中...
          </div>
        )}
      </div>
    </div>
  );
});

PdfViewer.displayName = 'PdfViewer';

export default PdfViewer;
